import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { PoweredByPropertyShield } from "shared/app/PoweredByPropertyShield";
import {
  fraudAlertActivityLines,
  fraudAlertActivityReviewUrl,
  type FraudAlertActivityMetadata,
  type FraudAlertActivityType
} from "shared/app/fraudAlertActivity";

interface Props {
  activityType: FraudAlertActivityType;
  metadata?: FraudAlertActivityMetadata;
  changes?: { field: string; new_display: string | null }[];
}

export const FraudAlertActivityDetails = ({
  activityType,
  metadata,
  changes
}: Props) => {
  const lines = fraudAlertActivityLines(activityType, metadata, changes);
  const reviewUrl = fraudAlertActivityReviewUrl(metadata, changes);

  return (
    <div className="space-y-2">
      {lines.map((line) => (
        <p key={line.label} className="text-sm text-content-400">
          {line.label}: <span className="font-medium">{line.value}</span>
        </p>
      ))}
      <div className="flex flex-wrap items-center gap-3">
        {reviewUrl ? (
          <Button
            type="button"
            size={ButtonSize.XS}
            variant={ButtonVariant.BASE}
            onClick={() =>
              window.open(reviewUrl, "_blank", "noopener,noreferrer")
            }
          >
            Review
          </Button>
        ) : null}
        <PoweredByPropertyShield variant="compact" />
      </div>
    </div>
  );
};
